import { BusyButton } from '@ztechapps/webui.button'
import { EmptyContent } from '@ztechapps/webui.util'
import React from 'react'
import { useError } from '@ztechapps/common.hook'
import { useInventoryBySerialNumberListContext } from './Context'

export const NotRequiredSerialNumberMessage = () => {
  const { productId, productRequiredSerialNumberActionResult } = useInventoryBySerialNumberListContext()
  const [onEnable, { error, loading }] = productRequiredSerialNumberActionResult
  useError(error)

  const onClick = async () => {
    await onEnable({
      productId: productId,
      requiredSerialNumber: true,
    })
  }
  return (
    <EmptyContent
      icon="barcode"
      subMessage="This product does not neeed to manage serial numbers. You can enable it though by setting clicking the button below"
      message="Serial number inventory is not applicable"
      action={<BusyButton isBusy={loading} text="Enable Product Serial Number" variant="primary" onClick={onClick} />}
    />
  )
}
